import React from 'react';
import { Heading } from "rebass";

export default React.forwardRef((props, ref) => {
	const { children, image, sx = {}, ...rest } = props;
	return  (
		<Heading
			{...rest}
			ref={ref}
			sx={{
				...sx,
				backgroundImage: `url('${image}')`,
				backgroundColor: 'text',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				WebkitBackgroundClip: 'text',
				WebkitTextFillColor: 'transparent'
			}}
		>
			{children}
		</Heading>
	)
});
